
















































import { Component, Mixins, Ref, Emit, Prop } from "vue-property-decorator";
import RulesMixin from "#/mixins/rulesMixin";
import { VForm } from "@/types";
import { AiVnplanAiSet, DefaultAiVnplanAiSet } from "#/model/admin/index";
import { ListPromptTemplate } from "@/views/aivnplan/types";

@Component
/** AI選択リスト編集(作成)ダイアログ */
export default class AiSetEditDialog extends Mixins(RulesMixin) {
  /** Ref */
  @Ref("form") private readonly form!: VForm;

  /** ダイアログの開閉状態 */
  @Prop({
    default: () => {
      false;
    },
  })
  private value!: boolean;

  /** AI選択リスト */
  @Prop({
    default: () => {
      DefaultAiVnplanAiSet;
    },
  })
  private aiSet!: AiVnplanAiSet;

  /** プロンプトテンプレート選択肢 */
  @Prop({
    default: () => {
      [];
    },
  })
  private promptChoice!: ListPromptTemplate[];

  /** getter */

  /** ダイアログの開閉状態 */
  private get Value() {
    return this.value;
  }
  private set Value(value: boolean) {
    this.input(value);
  }

  /** 関数 */

  /** 保存ボタン押下 */
  private async onSave() {
    if (!this.form.validate()) {
      await this.$openAlert("入力内容に不備があります。");
      return;
    }

    if (!(await this.$openConfirm("保存しますか？"))) {
      return;
    }

    this.form.resetValidation();
    this.saveAiSet();
  }

  /** キャンセルボタン押下 */
  private async onCancel() {
    this.form.resetValidation();
    this.cancelAiSet();
  }

  /** Emit */

  /** ダイアログの開閉状態の変更通知 */
  @Emit() private input(value: boolean) {
    return value;
  }

  @Emit("save:aiSet") private saveAiSet() {
    return;
  }

  @Emit("cancel:aiSet") private cancelAiSet() {
    return;
  }
}
